// PRODUCTION — insertion line shown between steps during drag-and-drop reorder
import React from 'react'
import tw from 'twin.macro'

export function FlowEditorStepDropIndicator() {
  return (
    <div aria-hidden css={tw`pointer-events-none flex items-center gap-1.5 px-3 py-0.5`}>
      <span css={tw`h-1.5 w-1.5 flex-shrink-0 rounded-full bg-primary-500`} />
      <span css={tw`h-0.5 flex-1 rounded-full bg-primary-500`} />
      <span css={tw`h-1.5 w-1.5 flex-shrink-0 rounded-full bg-primary-500`} />
    </div>
  )
}
